import { useState, useEffect, useContext, useCallback } from "react";
import { GlobalContext } from "../../Context/GlobalContext";

const useWhatsappNumbers = () => {
  const { baseUrl, basicAuth, userID, whatsappNumbers,
  setWhatsappNumbers,
  whatsappFetched,
  setWhatsappFetched, } = useContext(GlobalContext);

  const [loading, setLoading] = useState(false);

  const postRequest = useCallback(
    async (endpoint, body) => {
      if (!baseUrl || !basicAuth) return null;

      try {
        const res = await fetch(`${baseUrl}${endpoint}`, {
          method: "POST",
          headers: {
            Authorization: basicAuth,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        });

        return await res.json();
      } catch (err) {
        console.error("Whatsapp Numbers Error:", err);
        return null;
      }
    },
    [baseUrl, basicAuth],
  );

  const fetchWhatsappNumbers = useCallback(async () => {
   if (!userID || whatsappFetched) return;

    try {
      setLoading(true);

      const data = await postRequest("/Whatsapp/v1.0/getWhatsappNumbers", {
        userid: userID,
      });

      if (data?.responseCode === "00") {
        setWhatsappNumbers(data?.response || []);
        setWhatsappFetched(true);
      }
    } finally {
      setLoading(false);
    }
  }, [userID, postRequest, whatsappFetched]);

useEffect(() => {
  if (!userID) return;
  fetchWhatsappNumbers();
}, [userID]);

  return { whatsappNumbers, loading, fetchWhatsappNumbers };
};

export default useWhatsappNumbers;
